import { useContext } from 'react';
import { type TraBase } from '@ics-portal/tra';
import TraContext, { type TRAContextValues } from '../contexts/TraContext';

export default function useTRA<T = TraBase>(): TRAContextValues<T> {
    const context = useContext(TraContext);
    if (context === undefined) {
        throw new Error('useTra must be used within a TraProvider');
    }
    return context as TRAContextValues<T>;
}
